module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-cn":{"lockedProjectHint":"当前@:common.project为只读@:common.project，不能修改"}}')
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/project/show/setting/form/index.vue
// module id = 341
// module chunks = 3